<template>
  <div class="widget recent-material">
    <h3 class="title is-4">
      <slot></slot>
    </h3>
    <div v-if="recentMaterialsLoaded" class="columns is-multiline is-mobile">
      <div class="column is-3-desktop is-4-tablet is-6-mobile" v-for="post in recentMaterials(limit,paged)"
        :key="post.id">
        <material :post="post"></material>
      </div>
    </div>
    <div v-else>Loading...</div>
    <div class="buttons is-centered">
      <router-link :to="{ name: 'Materials'}" class="button is-primary">すべての素材を見る</router-link>
    </div>

  </div>
</template>

<script>
  import Material from "../partials/Material.vue";
  import {
    mapGetters
  } from "vuex";

  export default {
    props: ["limit", "paged"],
    computed: {
      ...mapGetters({
        recentMaterials: "recentMaterials",
        recentMaterialsLoaded: "recentMaterialsLoaded"
      })
    },

    mounted() {
      this.$store.dispatch("getMaterials", {
        limit: this.limit,
        paged: this.paged
      });
    },

    components: {
      Material
    }
  };
</script>